import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CreditWallet } from '@modules/credit-wallet/Domain/Entities/credit-wallet.entity';
import { LucideIconsModule } from '@shared/lucide-icons.module';
import { CreditBadgeService } from './credit-badge.service';
import { DisplayMode, MVP_CONVERSION_RATE } from '@modules/credit-wallet/Domain/display-mode';

@Component({
  selector: 'app-credit-badge',
  standalone: true,
  imports: [CommonModule, LucideIconsModule],
  templateUrl: './credit-badge.component.html',
  styleUrl: './credit-badge.component.scss',
})
export class CreditBadgeComponent implements OnInit, OnDestroy {
  wallet: CreditWallet | null = null;
  walletChecked = false;
  displayMode: DisplayMode = 'credits';
  private subs: Subscription[] = [];

  constructor(
    private readonly badgeService: CreditBadgeService,
    private readonly router: Router,
  ) {}

  get loading$() {
    return this.badgeService.loading$;
  }

  get formattedValue(): string {
    if (!this.wallet) return '···';
    if (this.displayMode === 'euros') {
      const euros = this.wallet.totalCredits * MVP_CONVERSION_RATE;
      return euros.toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) + ' €';
    }
    return this.wallet.totalCredits.toLocaleString('es') + ' cr';
  }

  ngOnInit(): void {
    this.subs.push(
      this.badgeService.wallet$.subscribe((w) => (this.wallet = w)),
      this.badgeService.displayMode$.subscribe((m) => (this.displayMode = m)),
      this.badgeService.walletChecked$.subscribe((c) => (this.walletChecked = c)),
    );

    this.badgeService.load();
    this.badgeService.startPolling();

    this.subs.push(
      this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe(() => this.badgeService.load()),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
    this.badgeService.stopPolling();
  }

  navigate(): void {
    const tenant = this.router.parseUrl(this.router.url).queryParams['tenant'];
    this.router.navigate(['/credits'], tenant ? { queryParams: { tenant } } : {});
  }
}
